import { RootState } from "../index";

export const requestSelector = (state: RootState) => state.request;
